import script from "./ToDoListCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./ToDoListCreate.vue?vue&type=script&setup=true&lang=js"

import "./ToDoListCreate.vue?vue&type=style&index=0&id=1d830ca1&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d830ca1"]])

export default __exports__